import React, { FC, /* ReactNode, */ useCallback, useState } from 'react';
/* import { format } from 'date-fns';
import {
    Channel,
    ChannelLogo,
    ChannelLogoFallback,
    Details,
    IconsAndMarkers,
    PlayOptionWrapper,
    RightSideIcons,
    StyledButton,
    Time,
} from './PlayOptionScreen.css';
import icons from '../../style';
import translate from '../../utils/fnTranslate'; */
import { Listing /* , Marker */ } from '../../types/Asset';
import { withNoScroll } from '../../hooks/withNoScroll/withNoScroll';
/* import { ContentMarker, StyledSVG } from '../../style/styled-components/reusable.css';
import { Picture } from '../Picture/Picture'; */
import { usePlayOptions } from '../../providers/usePlayOptions/PlayOptionsContext';
/* import { formatDate, isPast } from '../../utils/fnDate';
import { TIME_FORMAT_HH_MM } from '../../utils/fnGSParser';
import { MILLISECONDS } from '../../utils/TimeUnit';
import { getCatchupPlayerURL, getLivePlayerURL } from '../../utils/fnUrl';
import { useConfig } from '../../providers/useConfig/ConfigContext';
import { useBroadcastTimeCluster } from '../../hooks/useBroadcastTimeCluster/useBroadcastTimeCluster';
import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator';
import { getUniquePlayOptions } from '../../utils/fnData';
import { useAuth } from '../../providers/useAuth/AuthContext';
import { getBroadcastCardContentMarkerValue } from '../../utils/fnContentMarker'; */
import { useSubscriptionChangedObserver } from '../../providers/useSubscription/SubscriptionContext';

/* const PlayOptionItem: FC<{ asset: Listing; index: number; onSubscribe: (packageId: string) => void }> = ({ asset, index, onSubscribe }) => {
    const { channel, start, duration, id, bookmark, isLive } = asset;
    const { config } = useConfig();
    const { bookmark_threshold } = config?.app_config?.player_settings ?? {};
    const timeCluster = useBroadcastTimeCluster(asset);
    const { initSubscribeFlow } = useSubscription();

    const startTime = start * 1000;
    const endTime = (start + duration) * 1000;

    const getContentMarker = (): ReactNode => {
        const contentMarker: Marker = getBroadcastCardContentMarkerValue(isLive, timeCluster);
        return contentMarker && <ContentMarker marker={contentMarker}>{contentMarker.value}</ContentMarker>;
    };

    const getProgress = (): number => {
        const dur = MILLISECONDS.toSeconds(endTime - startTime);
        return (bookmark * 100) / dur;
    };

    const hasProgress = (): boolean => {
        const progress = getProgress();
        return progress > 0 && progress < bookmark_threshold;
    };

    const getButtonText = () => {
        if (!channel.subscription) {
            return 'ORDER_BUTTON';
        }

        if (timeCluster === 'LIVE') {
            if (hasProgress()) {
                if (bookmark > MILLISECONDS.toSeconds(Date.now() - start)) {
                    return 'SCREEN_DETAIL_PLAY_BUTTON';
                }
                return 'SCREEN_DETAIL_RESUME_BUTTON';
            }
            return 'SCREEN_DETAIL_PLAY_BUTTON';
        }

        if (timeCluster === 'PAST') {
            if (hasProgress()) {
                return 'SCREEN_DETAIL_RESUME_BUTTON';
            }

            return 'SCREEN_DETAIL_PLAY_BUTTON';
        }

        return 'SCREEN_DETAIL_PLAY_BUTTON';
    };

    const getLinkToWatch = () => {
        return timeCluster === 'LIVE' ? getLivePlayerURL(channel.id) : getCatchupPlayerURL(id);
    };

    return (
        <PlayOptionWrapper>
            <Channel>
                <ChannelLogo>
                    <Picture src={channel.logo} hPosition={'center'} vPosition={'center'} fit={'scale-down'}>
                        {channel.name && <ChannelLogoFallback>{channel.name}</ChannelLogoFallback>}
                    </Picture>
                </ChannelLogo>
            </Channel>
            <Details>
                <IconsAndMarkers>
                    {getContentMarker()}
                    {isPast(MILLISECONDS.toSeconds(endTime)) && <StyledSVG key={'catchup'} svg={icons.catchUpIcon} />}
                </IconsAndMarkers>
                <Time>{`${formatDate(new Date(startTime))} ${format(startTime, TIME_FORMAT_HH_MM)} - ${format(
                    endTime,
                    TIME_FORMAT_HH_MM
                )}`}</Time>
                <RightSideIcons>{!channel.subscription && <StyledSVG svg={icons.lockIcon} />}</RightSideIcons>
            </Details>

            <StyledButton
                label={translate(getButtonText())}
                link={channel.subscription ? getLinkToWatch() : undefined}
                onClick={
                    !channel.subscription
                        ? () => {
                              initSubscribeFlow(undefined, {
                                  type: 'Channel',
                                  code: channel.productCode,
                              });
                              onSubscribe(channel.productCode);
                          }
                        : undefined
                }
                isPrimary={index === 0}
            />
        </PlayOptionWrapper>
    );
}; */

const OptionSelector: FC<{
    asset: Listing[];
    refEvent: string;
    onClose: () => void;
    load: (refEvent: string) => void;
}> = ({ /* asset, */ refEvent, load }) => {
    /* const { getReplayWindowTimeFrame } = useAuth(); */
    /*     const filteredPlayOptions = getUniquePlayOptions(asset, getReplayWindowTimeFrame(), null, refEvent, true); */

    const [packageToSubscribe] = useState<string>();

    const onSubscriptionChange = useCallback(() => {
        load(refEvent);
    }, [refEvent, load]);

    useSubscriptionChangedObserver([packageToSubscribe], onSubscriptionChange, [onSubscriptionChange, packageToSubscribe]);

    return null;
};

const OptionScreen = withNoScroll(OptionSelector);

export const PlayOptionSelector: FC = () => {
    const { closeSelector, playOptionsData: asset, referenceEventId /* fetching, load */ } = usePlayOptions();

    /* if (fetching && !asset) {
        return <LoadingIndicator overlay={true} />;
    } */

    if (!asset) {
        return null;
    }

    return <OptionScreen onClose={closeSelector} asset={asset} refEvent={referenceEventId()} /* load={load} */ />;
};
